import {
  Button as MuiButton,
  TextField as MuiTextField,
  Switch as MuiSwitch,
  Link as MuiLink,
  IconButton as MuiIconButton,
  Checkbox as MuiCheckbox,
  ButtonBase as MuiButtonBase,
} from '@mui/material';
import { withAnalyticsElement } from './AnalyticsWrapperComponent';
import SelectFormControl from './../../components/UI-Elements/SelectFormControl';
import TextFormControl from './../../components/UI-Elements/TextFormControl';
import TextFormStateControl from './../../components/UI-Elements/TextFormStateControl';
import RadioGroup from '@mui/material/RadioGroup';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import SelectSeasonFormControl from './../../components/UI-Elements/SelectSeasonFormControl';

export const Button = withAnalyticsElement(MuiButton, 'button');
export const ButtonBase = withAnalyticsElement(MuiButtonBase, 'button');
export const TextField = withAnalyticsElement(MuiTextField, 'textField');
export const Switch = withAnalyticsElement(MuiSwitch, 'checkbox');
export const Checkbox = withAnalyticsElement(MuiCheckbox, 'checkbox');
export const IconButton = withAnalyticsElement(MuiIconButton, 'button');
export const Link = withAnalyticsElement(MuiLink, 'button');
export const TrackedSelectFormControl = withAnalyticsElement(SelectFormControl, 'selector');
export const TrackedTextFormControl = withAnalyticsElement(TextFormControl, 'update');
export const TrackedLiveTextFormControl = withAnalyticsElement(TextFormControl, 'textField');
export const TrackedTextFormStateControl = withAnalyticsElement(TextFormStateControl, 'update');
export const TrackedRadioGroup = withAnalyticsElement(RadioGroup, 'selector');
export const TrackedDesktopDatePicker = withAnalyticsElement(DesktopDatePicker, 'selector');
export const TrackedSelectSeasonFormControl = withAnalyticsElement(
  SelectSeasonFormControl,
  'selector'
);
